import { WrapperRetailer, ArticleOrgWrapper } from "components/components" // lazy
import { useConsole } from "contexts/Console"
import { Suspense } from "react"
import generateComponents, { parseModularBlock } from "utils/generateComponents"
import Back from "components/nav-v2/Back"
import Tools from "components/nav-v2/Tools"

const Wrap = ({ back, wrapper, controlslayout, header, subNav, tools, csrAttrs, components, pageviewCallback, nofooter, footer }) => {
  const console = useConsole()

  console.verbose("Wrap<%s>(%o)", wrapper, { back, header, subNav })
  switch (wrapper) {
    case "retailer":
      return (
        <Suspense>
          <WrapperRetailer
            back={back}
            tools={tools}
            header={header}
            subNav={subNav}
            csrAttrs={csrAttrs}
            components={components}
            pageviewCallback={pageviewCallback}
            footer={footer}
          />
        </Suspense>
      )
    case "article_org":
      return (
        <Suspense>
          <ArticleOrgWrapper
            back={back}
            tools={tools}
            header={header}
            subNav={subNav}
            csrAttrs={csrAttrs}
            components={components}
            pageviewCallback={pageviewCallback}
            footer={footer}
          />
        </Suspense>
      )
    default: {
      return controlslayout ? (
        generateComponents(parseModularBlock(components, { console }), { console, pageviewCallback })
      ) : (
        <>
          {generateComponents(header, { console })}
          {generateComponents(subNav, { console })}
          {back && <Back />}
          {tools && <Tools {...tools} />}
          <main id='main' {...csrAttrs}>
            {generateComponents(parseModularBlock(components, { console }), { console, pageviewCallback })}
          </main>
          {!nofooter && generateComponents(footer, { console })}
        </>
      )
    }
  }
}

export default Wrap
